import { PropsWithChildren } from 'react';
import { Text } from '@rsos/base-components';
import { BlurButton } from './BlurButton';
import {
  StyledControls,
  StyledControlsSection,
  StyledButtonRow,
} from './DispatcherControls.styles';
import { EndCallButton } from './EndCallButton';
import { FlipCameraButton } from './FlipCameraButton';
import { GoDarkButton } from './GoDarkButton';
import { MuteButton } from './MuteButton';
import { MuteCallerButton } from './MuteCallerButton';

export const DispatcherControls = ({
  handleCallEnding,
}: {
  handleCallEnding: () => void;
}) => {
  return (
    <StyledControls>
      <DispatcherControlsSection key="caller-controls" title="Caller Controls">
        <GoDarkButton />
        <MuteCallerButton />
        <FlipCameraButton />
      </DispatcherControlsSection>
      <DispatcherControlsSection key="unite-controls" title="UNITE Controls">
        <BlurButton />
        <MuteButton />
        <EndCallButton onClick={handleCallEnding} />
      </DispatcherControlsSection>
    </StyledControls>
  );
};

/**
 * One bounded subsection of the controls; caller controls or dispatcher
 * controls.
 */
function DispatcherControlsSection({
  title,
  children,
}: PropsWithChildren<{ title: string }>) {
  return (
    <StyledControlsSection>
      <StyledButtonRow>{children}</StyledButtonRow>
      <Text size="xsmall">{title}</Text>
    </StyledControlsSection>
  );
}
